// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eswitch_fpg_web--Result-module--loader--suQG8PV1IuKYk3HJ5p70 {
  height: "450vh";
  display: "flex";
  justify-content: "center";
  align-items: "center";
  margin-top: 350px;
}

.eswitch_fpg_web--Result-module--authButton--nqz9QeTiy8xzi8ksDfpG {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}

.eswitch_fpg_web--Result-module--wrapper--ROg1DqrtuKzHPsrtEXBV {
  padding: 40px;
  letter-spacing: 0 !important;
  margin: 4rem 0;
  background-color: white;
}

.eswitch_fpg_web--Result-module--h3--sXq_qe5NcEQhliu7JecR,
.eswitch_fpg_web--Result-module--h4--J2G8gGAPaT2WVbo8zQPe {
  letter-spacing: 0 !important;
  font-family: var(--fmc-font--inter);
}

.eswitch_fpg_web--Result-module--h4inline--YzwMfalc6r7bHNX4ltgA {
  display: inline-block;
  letter-spacing: 0 !important;
  font-family: var(--fmc-font--inter);
  font-size: 24px !important;
  padding-left: 0px;
}

.eswitch_fpg_web--Result-module--h3--sXq_qe5NcEQhliu7JecR {
  margin-bottom: 32px !important;
  font-family: var(--fmc-font--ford-motion) !important;
}

.eswitch_fpg_web--Result-module--h4--J2G8gGAPaT2WVbo8zQPe {
  font-size: 24px !important;
  font-family: var(--fmc-font--inter);
  text-align: left;
  padding-left: 33px;
}

.eswitch_fpg_web--Result-module--p--E_yxZLSjNadMoBgcqH7b {
  color: var(--fds-color--gray3) !important;
  letter-spacing: 0 !important;
  font-family: var(--fmc-font--inter);
  text-align: left;
  padding-left: 33px;
}

.eswitch_fpg_web--Result-module--content--aoAaCqE0n8hv1nftpWGu {
  border: 1px solid #c8c9c7;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.eswitch_fpg_web--Result-module--headerWrapper--iCIAPeVUD8CcktwN8S_O {
  padding-top: 40px;
  margin-bottom: 20px;
}

.eswitch_fpg_web--Result-module--headerTitle--bTK8OZTKBtHMLHeAYpRk {
  text-align: center;
  font-family: var(--fmc-font--ford-motion) !important;
  margin: 0;
}

.eswitch_fpg_web--Result-module--imageWrapper--sz5CQSH2DDHJ0mbmlmO7 {
  display: flex;
  justify-content: center;
}

.eswitch_fpg_web--Result-module--transitImage--ecKrESX21BoH2qMs8RVF {
  /* Adjust the padding or other styles as needed for proper positioning */
  padding: 16px;
  width: 256px;
  height: 170.45px;
}

.eswitch_fpg_web--Result-module--transitImage--ecKrESX21BoH2qMs8RVF.eswitch_fpg_web--Result-module--reduceOpacity--je4vdngqpVJ9BEpXEjRb {
  opacity: 0.5;
}

.eswitch_fpg_web--Result-module--line--In_czKsBN13qjBQwqxxc {
  height: 1px;
  background-color: #c8c9c7;
  margin: 20px 32px;
  position: relative;
}

.eswitch_fpg_web--Result-module--line--In_czKsBN13qjBQwqxxc::before,
.eswitch_fpg_web--Result-module--line--In_czKsBN13qjBQwqxxc::after {
  content: "";
  position: absolute;
  background-color: inherit;
  height: 100%;
  width: 32px;
}

.eswitch_fpg_web--Result-module--line--In_czKsBN13qjBQwqxxc::before {
  left: 0;
}

.eswitch_fpg_web--Result-module--line--In_czKsBN13qjBQwqxxc::after {
  right: 0;
}

.eswitch_fpg_web--Result-module--infoWrapper--QvHKuKiONKTZk3MPHGsb {
  display: flex;
  justify-content: center;
  justify-content: flex-start;
}

.eswitch_fpg_web--Result-module--infoPair--YvDOjP0BKtIHZOO6Msk9 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.eswitch_fpg_web--Result-module--buttonWrapper--abUbHr4vs1PRIkQPSXzX {
  padding-left: 33px;
  padding-top: 15px;
  margin-left: auto;
  width: 100%;
}

.eswitch_fpg_web--Result-module--mobileButtonWrapper--FWZLNHmCWAXtKJEdPUnI {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 15px;
  width: 100%;
}

.eswitch_fpg_web--Result-module--fullWidth--us1zLGFUh4FrSXX8_ZDQ {
  width: 100%;
}

.eswitch_fpg_web--Result-module--grayBox--T6GB0WXDjPDzgjgzpfiN {
  background-color: #f4f4f4;
  margin: 20px 32px;
}

.eswitch_fpg_web--Result-module--grayBox--T6GB0WXDjPDzgjgzpfiN > * {
  padding: 16px;
}

.eswitch_fpg_web--Result-module--iconImage--ncyr31t7RjUt_SKhDGQD {
  width: 22px;
  height: 22px;
  max-width: 100%;
  max-height: 100%;
}

.eswitch_fpg_web--Result-module--iconDetail--jvwrycvCRzBlk9OzPWNw {
  color: var(--fds-color--gray3) !important;
  padding-left: 10px;
}

.eswitch_fpg_web--Result-module--highlight--FDErAoDFxp95wPPIdRqQ {
  color: #00095b;
  font-weight: bold;
}

.eswitch_fpg_web--Result-module--dottedUnderline--mzvYrGe35zozA884eMOP {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  padding-left: 33px;
  font-family: var(--fmc-font--ford-motion) !important;
}

@media (max-width: 767px) {
  .eswitch_fpg_web--Result-module--hideMobile--OIZZSJWcqrD_ri8Fbiny {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .eswitch_fpg_web--Result-module--hideDesktop--AJH9GmWYheP_RXWS0GAu {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.module.scss","webpack://./src/components/QuickEstimateCalculator/Result.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;ACCJ;;ADEA;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;ACCJ;;AAXA;EACI,aAAA;EACA,4BAAA;EACA,cAAA;EACA,uBAAA;AAcJ;;AAXA;;EAEI,4BAAA;EACA,mCAAA;AAcJ;;AAXA;EACI,qBAAA;EACA,4BAAA;EACA,mCAAA;EACA,0BAAA;EACA,iBAAA;AAcJ;;AAXA;EACI,8BAAA;EACA,oDAAA;AAcJ;;AAXA;EACI,0BAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;AAcJ;;AAXA;EACI,yCAAA;EACA,4BAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;AAcJ;;AAXA;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAcJ;;AAXA;EACI,iBAAA;EACA,mBAAA;AAcJ;;AAXA;EACI,kBAAA;EACA,oDAAA;EACA,SAAA;AAcJ;;AAXA;EACI,aAAA;EACA,uBAAA;AAcJ;;AAXA;EACI,wEAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAcJ;;AAbI;EACI,YAAA;AAeR;;AAXA;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAcJ;;AAXA;;EAEI,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;AAcJ;;AAXA;EACI,OAAA;AAcJ;;AAXA;EACI,QAAA;AAcJ;;AAXA;EACI,aAAA;EACA,uBAAA;EAEA,2BAAA;AAaJ;;AAVA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;AAaJ;;AAVA;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AAaJ;;AAVA;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAaJ;;AAVA;EACI,WAAA;AAaJ;;AAVA;EACI,yBAAA;EACA,iBAAA;AAaJ;;AAVA;EACI,aAAA;AAaJ;;AAVA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAaJ;;AAVA;EACI,yCAAA;EACA,kBAAA;AAaJ;;AAVA;EACI,cAAA;EACA,iBAAA;AAaJ;;AAVA;EACI,yCAAA;UAAA,iCAAA;EACA,kBAAA;EACA,oDAAA;AAaJ;;AATI;EADJ;IAEQ,wBAAA;EAaN;AACF;;AATI;EADJ;IAEQ,wBAAA;EAaN;AACF","sourcesContent":[".loader {\n    height: '450vh';\n    display: 'flex';\n    justify-content: 'center';\n    align-items: 'center';\n    margin-top: 350px;\n}\n\n.authButton {\n    margin-top: 20px;\n    display: flex;\n    justify-content: flex-end;\n    margin-right: 10px;\n}\n\n$fds-breakpoints: (\n  'fds-xs': 360px,\n  'fds-sm': 600px,\n  'fds-md': 1024px,\n  'fds-lg': 1440px,\n  'fds-xl': 1920px\n);\n\n$fds-breakpoints-max: (\n  'fds-xxs': 359px,\n  'fds-xs': 599px,\n  'fds-sm': 1023px,\n  'fds-md': 1439px,\n  'fds-lg': 1919px\n);\n\n$fds-breakpoints-landscape-max: (\n  'handheld': 480px,\n  'tablet': 1024px\n);\n\n$custom-breakPoints-max:(\n  'tablet':767px,\n  'desktop':1023px\n);\n\n$custom-breakPoints-min:(\n  'tablet':768px,\n  'desktop':1023px\n)\n\n","@import '../../App.module.scss';\n\n.wrapper {\n    padding: 40px;\n    letter-spacing: 0 !important;\n    margin: 4rem 0;\n    background-color: white;\n}\n\n.h3,\n.h4 {\n    letter-spacing: 0 !important;\n    font-family: var(--fmc-font--inter);\n}\n\n.h4inline {\n    display: inline-block;\n    letter-spacing: 0 !important;\n    font-family: var(--fmc-font--inter);\n    font-size: 24px !important;\n    padding-left: 0px;\n}\n\n.h3 {\n    margin-bottom: 32px !important;\n    font-family: var(--fmc-font--ford-motion) !important;\n}\n\n.h4 {\n    font-size: 24px !important;\n    font-family: var(--fmc-font--inter);\n    text-align: left;\n    padding-left: 33px;\n}\n\n.p {\n    color: var(--fds-color--gray3) !important;\n    letter-spacing: 0 !important;\n    font-family: var(--fmc-font--inter);\n    text-align: left;\n    padding-left: 33px;\n}\n\n.content {\n    border: 1px solid #c8c9c7;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.headerWrapper {\n    padding-top: 40px;\n    margin-bottom: 20px;\n}\n\n.headerTitle {\n    text-align: center;\n    font-family: var(--fmc-font--ford-motion) !important;\n    margin: 0;\n}\n\n.imageWrapper {\n    display: flex;\n    justify-content: center;\n}\n\n.transitImage {\n    /* Adjust the padding or other styles as needed for proper positioning */\n    padding: 16px;\n    width: 256px;\n    height: 170.45px;\n    &.reduceOpacity {\n        opacity: 0.5;\n    }\n}\n\n.line {\n    height: 1px;\n    background-color: #c8c9c7;\n    margin: 20px 32px;\n    position: relative;\n}\n\n.line::before,\n.line::after {\n    content: '';\n    position: absolute;\n    background-color: inherit;\n    height: 100%;\n    width: 32px;\n}\n\n.line::before {\n    left: 0;\n}\n\n.line::after {\n    right: 0;\n}\n\n.infoWrapper {\n    display: flex;\n    justify-content: center;\n\n    justify-content: flex-start;\n}\n\n.infoPair {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n}\n\n.buttonWrapper {\n    padding-left: 33px;\n    padding-top: 15px;\n    margin-left: auto;\n    width: 100%;\n}\n\n.mobileButtonWrapper {\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-top: 15px;\n    width: 100%;\n}\n\n.fullWidth {\n    width: 100%;\n}\n\n.grayBox {\n    background-color: #f4f4f4;\n    margin: 20px 32px;\n}\n\n.grayBox > * {\n    padding: 16px;\n}\n\n.iconImage {\n    width: 22px;\n    height: 22px;\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.iconDetail {\n    color: var(--fds-color--gray3) !important;\n    padding-left: 10px;\n}\n\n.highlight {\n    color: #00095b;\n    font-weight: bold;\n}\n\n.dottedUnderline {\n    text-decoration: underline dotted;\n    padding-left: 33px;\n    font-family: var(--fmc-font--ford-motion) !important;\n}\n\n.hideMobile {\n    @media (max-width: map-get($custom-breakPoints-max,  'tablet')) {\n        display: none !important;\n    }\n}\n\n.hideDesktop {\n    @media (min-width: map-get($custom-breakPoints-min,  'tablet')) {\n        display: none !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `eswitch_fpg_web--Result-module--loader--suQG8PV1IuKYk3HJ5p70`,
	"authButton": `eswitch_fpg_web--Result-module--authButton--nqz9QeTiy8xzi8ksDfpG`,
	"wrapper": `eswitch_fpg_web--Result-module--wrapper--ROg1DqrtuKzHPsrtEXBV`,
	"h3": `eswitch_fpg_web--Result-module--h3--sXq_qe5NcEQhliu7JecR`,
	"h4": `eswitch_fpg_web--Result-module--h4--J2G8gGAPaT2WVbo8zQPe`,
	"h4inline": `eswitch_fpg_web--Result-module--h4inline--YzwMfalc6r7bHNX4ltgA`,
	"p": `eswitch_fpg_web--Result-module--p--E_yxZLSjNadMoBgcqH7b`,
	"content": `eswitch_fpg_web--Result-module--content--aoAaCqE0n8hv1nftpWGu`,
	"headerWrapper": `eswitch_fpg_web--Result-module--headerWrapper--iCIAPeVUD8CcktwN8S_O`,
	"headerTitle": `eswitch_fpg_web--Result-module--headerTitle--bTK8OZTKBtHMLHeAYpRk`,
	"imageWrapper": `eswitch_fpg_web--Result-module--imageWrapper--sz5CQSH2DDHJ0mbmlmO7`,
	"transitImage": `eswitch_fpg_web--Result-module--transitImage--ecKrESX21BoH2qMs8RVF`,
	"reduceOpacity": `eswitch_fpg_web--Result-module--reduceOpacity--je4vdngqpVJ9BEpXEjRb`,
	"line": `eswitch_fpg_web--Result-module--line--In_czKsBN13qjBQwqxxc`,
	"infoWrapper": `eswitch_fpg_web--Result-module--infoWrapper--QvHKuKiONKTZk3MPHGsb`,
	"infoPair": `eswitch_fpg_web--Result-module--infoPair--YvDOjP0BKtIHZOO6Msk9`,
	"buttonWrapper": `eswitch_fpg_web--Result-module--buttonWrapper--abUbHr4vs1PRIkQPSXzX`,
	"mobileButtonWrapper": `eswitch_fpg_web--Result-module--mobileButtonWrapper--FWZLNHmCWAXtKJEdPUnI`,
	"fullWidth": `eswitch_fpg_web--Result-module--fullWidth--us1zLGFUh4FrSXX8_ZDQ`,
	"grayBox": `eswitch_fpg_web--Result-module--grayBox--T6GB0WXDjPDzgjgzpfiN`,
	"iconImage": `eswitch_fpg_web--Result-module--iconImage--ncyr31t7RjUt_SKhDGQD`,
	"iconDetail": `eswitch_fpg_web--Result-module--iconDetail--jvwrycvCRzBlk9OzPWNw`,
	"highlight": `eswitch_fpg_web--Result-module--highlight--FDErAoDFxp95wPPIdRqQ`,
	"dottedUnderline": `eswitch_fpg_web--Result-module--dottedUnderline--mzvYrGe35zozA884eMOP`,
	"hideMobile": `eswitch_fpg_web--Result-module--hideMobile--OIZZSJWcqrD_ri8Fbiny`,
	"hideDesktop": `eswitch_fpg_web--Result-module--hideDesktop--AJH9GmWYheP_RXWS0GAu`
};
export default ___CSS_LOADER_EXPORT___;
